var $imports = require("../../../../../node_modules/art-template/lib/runtime.js");
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', $escape = $imports.$escape, COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME = $data.COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME, targetName = $data.targetName, targetCls = $data.targetCls, i = $data.i, targets = $data.targets, more = $data.more, teams = $data.teams;
    $$out += '<tooltip-layer @shortcut-context="';
    $$out += $escape(COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME);
    $$out += '" name=';
    $$out += $escape(targetName);
    $$out += ' class="fv--ui-text-selection-tooltip ';
    $$out += $escape(targetCls);
    $$out += '">\n  ';
    for (var i = 0; i < targets.length; i++) {
        $$out += '\n    <xbutton name=';
        $$out += $escape(targets[i].name);
        $$out += ' icon-class="fx-icon-md ';
        $$out += $escape(targets[i].icon);
        $$out += '" clr-value="';
        $$out += $escape(targets[i].clrValue);
        $$out += '"  text=';
        $$out += $escape(targets[i].text);
        $$out += ' ></xbutton>\n  ';
    }
    $$out += '\n  ';
    if (more) {
        $$out += '\n    <div class="line-seperator"></div>\n    ';
        for (var i = 0; i < more.length; i++) {
            $$out += '\n      <xbutton name=';
            $$out += $escape(more[i].name);
            $$out += ' icon-class="fx-icon-md ';
            $$out += $escape(more[i].icon);
            $$out += '" clr-value="';
            $$out += $escape(more[i].clrValue);
            $$out += '" text=';
            $$out += $escape(targets[i].text);
            $$out += ' ></xbutton>\n    ';
        }
        $$out += '\n  ';
    }
    $$out += '\n  ';
    if (teams) {
        $$out += '\n    <div class="line-seperator"></div>\n    ';
        for (var i = 0; i < teams.length; i++) {
            $$out += '\n      <xbutton name=';
            $$out += $escape(teams[i].name);
            $$out += ' icon-class="fx-icon-md ';
            $$out += $escape(teams[i].icon);
            $$out += '" clr-value="';
            $$out += $escape(teams[i].clrValue);
            $$out += '" ></xbutton>\n    ';
        }
        $$out += '\n  ';
    }
    $$out += '\n</tooltip-layer>';
    return $$out;
};